
























































































































import { Component, Vue } from "vue-property-decorator";
// types
import { Font, FontStatusEnum } from "@/services/fonts/types";
import { fontFields } from "@/components/fonts/fields/fontFields";
import { Guid } from "guid-typescript";
// validation
import validate from "@/directives/validate";
import { addFontValidators, removeFontValidators } from "@/components/fonts/validators";
import { validateForm } from "@/services/validation/validationService";
// services
import { changeStatus, deleteFont, getAllFonts, saveFont, LoadCustomWebFonts } from "@/services/fonts/fontsService";
// components
import FontDeleteModal from "@/components/fonts/modals/FontDeleteModal.vue";
import FontAlreadyExistsModal from "@/components/fonts/modals/FontAlreadyExistsModal.vue";
import SelectValidFontTypeModal from "@/components/fonts/modals/SelectValidFontTypeModal.vue";

@Component({
    components: {
        FontDeleteModal,
        FontAlreadyExistsModal,
        SelectValidFontTypeModal
    },
    directives: {
        validate
    }
})
export default class Fonts extends Vue {
    // local
    localFonts = [] as Font[];
    fields = fontFields;
    validators = {};
    searchText = "";
    editFont = false;
    selectedRow = "";
    private tmpNewFile: File = {} as File;
    sorting = {} as any;

    // lifecycle hooks
    created() {
        this.loadFonts();
    }

    // computed
    get filteredData() {
        const fonts = this.localFonts.filter(
            x => (this.searchText === "" ? true : x.displayName.toLowerCase().includes(this.searchText.toLowerCase()) ||
            x.technicalName.toLowerCase().includes(this.searchText.toLowerCase())));

        if (!this.editFont) {
            if (!this.sorting.sortBy) fonts.sort((a: Font, b: Font) => a.technicalName.localeCompare(b.technicalName));
            else {
                fonts.sort((a: any, b: any) => a[this.sorting.sortBy].localeCompare(b[this.sorting.sortBy]));
                if (this.sorting.sortDesc) fonts.reverse();
            }
        }
        return fonts;
    }

    getFontType(item: Font) {
        if (item.hasFile && item.type) {
            switch (item.type.toLowerCase()) {
            case ".woff2":
                return "Webfont .WOFF2";
            case ".ttf":
                return "Webfont .TTF";
            case ".woff":
                return "Webfont .WOFF";
            default:
                return "";
            }
        }
        return "";
    }

    // methods
    async loadFonts() {
        this.localFonts = await getAllFonts();
        this.tmpNewFile = {} as File;
        this.localFonts.sort((a, b) => a.technicalName.localeCompare(b.technicalName)).forEach(x => addFontValidators(this.validators, x.id));
    }

    addNewFont() {
        this.editFont = true;
        const font = {} as Font;
        font.id = Guid.create().toString();
        this.selectedRow = font.id;
        font.status = FontStatusEnum.Active;
        if (this.tmpNewFile.type || this.tmpNewFile.name) {
            font.technicalName = this.tmpNewFile.name.substr(0, this.tmpNewFile.name.indexOf("."));
            font.displayName = this.tmpNewFile.name.substr(0, this.tmpNewFile.name.indexOf("."));
            font.hasFile = true;
        }
        addFontValidators(this.validators, font.id);
        this.localFonts.unshift(font);
    }

    async saveFont(item: Font) {
        const duplicate = this.localFonts.some(x => (x.displayName === item.displayName || x.technicalName === item.technicalName) && x.id !== item.id);
        if (duplicate) {
            (this.$refs.fontExistsModal as any).open(item);
        }
        if (!await validateForm([this.validators]) || duplicate) return;
        this.editFont = false;
        const formData = new FormData();
        formData.append("file", this.tmpNewFile);
        formData.append("model", JSON.stringify(item));
        saveFont(formData).then(() => {
            this.loadFonts();
            this.tmpNewFile = {} as File;
            (this.$refs.fileInput as any).value = null;
            LoadCustomWebFonts();
        });
    }

    async deleteFont(id: string) {
        this.editFont = false;
        this.tmpNewFile = {} as File;
        const item = this.localFonts.find(x => x.id === id);
        if (!item) return;
        if (!await validateForm([this.validators])) {
            this.localFonts.splice(this.localFonts.indexOf(item), 1);
            return;
        }
        (this.$refs.fontDeleteModal as any).open(item);
    }

    cancelEditing(id: string) {
        this.editFont = false;
        this.tmpNewFile = {} as File;
        (this.$refs.fileInput as any).value = null;
        this.loadFonts();
    }

    onFontDelete(item: Font) {
        this.localFonts.splice(this.localFonts.indexOf(item), 1);
        deleteFont(item.id).then(() => {
            removeFontValidators(this.validators, item.id);
            this.loadFonts();
        });
    }

    toggleActive(item: Font) {
        item.status = item.status === FontStatusEnum.Active ? FontStatusEnum.Disabled : FontStatusEnum.Active;
        changeStatus(item).then(() => this.loadFonts());
    }

    editRow(id: string) {
        this.editFont = true;
        this.selectedRow = id;
    }

    rowClass(item: Font, type: string) {
        return type === "row" && item.id === this.selectedRow && this.editFont ? "b-table-row-selected table-active" : "";
    }

    openFileSelection(): void {
        (this.$refs.fileInput as any).click();
    }

    onFilesChanged(event: any) {
        if (!event.target.files[0]) return;
        this.tmpNewFile = event.target.files[0];
        const fontType = this.tmpNewFile.name.substr(this.tmpNewFile.name.indexOf(".") + 1).toLowerCase();
        if (fontType === "woff" || fontType === "woff2" || fontType === "ttf") {
            this.addNewFont();
        } else {
            (this.$refs.validFontTypeModal as any).open();
            this.tmpNewFile = {} as File;
        }
    }

    sortChanged(val: any) {
        this.sorting = val;
    }

    back() {
        window.history.go(-1);
    }
}
